import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { Table, Input, Button, Row, Col, FormGroup, Label, } from "reactstrap";
import { ActividadesPlanificadas, DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidorPlanHEDTO, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO, unidadesEspeciales } from './TypesPlanificacionHE';

import { ReactComponent as EliminarSVG } from "./../../../../assets/icons/HorasExtras/eliminar.svg"
import { calcularValorHorabyRMU, calcularValorHoraExtraordinariabyRMU, calcularValorHoraSuplementariasbyRMU, calcularValorTotalExtraordinarias, calcularValorTotalHora, calcularValorTotalSuplementarias, GuardarPlanificacionbyServidor } from './FunctionsPlanificacionHE';

import ExitoSVG from "./../../../../assets/icons/HorasExtras/Exitosa.svg"
import ErrorSVG from "./../../../../assets/icons/HorasExtras/Error.svg"
import WarningSVG from "./../../../../assets/icons/HorasExtras/Informativa R.svg"
import Swal from 'sweetalert2'
import SelectItem2 from 'components/Varios/SelectNew';

type Props = {
    estadoPlanificacion: string,
    actividades: ActividadesPlanificadas[]
    ObtenerActividadesByRegimen: (idRegimenLaboral: number) => Promise<any>;
    idRegimenLaboral: number
    idPersona: number
    rmu: string
    recargarInformacion: () => Promise<void>
    paramsHorasMesPlanificacionHE: ParamsHorasMesPlanificacionHEDTO[]
    novedadesServidores: NovedadesServidoresHEDTO[]
    onPlanificacionSave: (planificacion: DetalleServidorPlanHEDTO) => void
    onCancel: () => void
    mensajeNovedad: string,
    tipo: "PR" | "PL" | "MD",
    idUnidadAprueba?: number,
    nombreUnidadAprueba?: string,
    regimenLaboralesPlan?: DetalleRegimenLaboralHEDTO[];
    puedeRealizarAccion?: boolean
    gruposActividad: DetalleGrupoActividadHEDTO[];
    factorMultiplicativo?: number
}

type ModalConfirmacionActividad = {
    showModal: boolean,
    solicitud: DetalleServidorPlanHEDTO,
    content: HTMLElement | undefined
}



const TableActividadServidorHE: React.FC<Props> = (
    { actividades,
        ObtenerActividadesByRegimen,
        idRegimenLaboral,
        idPersona,
        rmu,
        recargarInformacion,
        paramsHorasMesPlanificacionHE,
        onPlanificacionSave,
        onCancel,
        estadoPlanificacion,
        mensajeNovedad,
        idUnidadAprueba,
        nombreUnidadAprueba,
        regimenLaboralesPlan,
        tipo,
        puedeRealizarAccion,
        gruposActividad,
        factorMultiplicativo,
    }) => {

    const defaultServidorPlanificado = {
        idregimenLaboral: idRegimenLaboral,
        idpersona: idPersona,
        rmu: rmu,
        actividades: [],
    }

    const defaultDetalleServidorPlan: DetalleServidorPlanHEDTO = {
        idregimenLaboral: 0,
        idpersona: 0,
        rmu: '',
        actividades: [],
    };

    const defaultStateModalConfirmacionAct = {
        showModal: false,
        solicitud: defaultDetalleServidorPlan,
        content: undefined
    }

    const [initialRows, setinitialRows] = useState<ActividadesPlanificadas[]>([...actividades]);
    const [rows, setRows] = useState<ActividadesPlanificadas[]>([...actividades]);
    const [availableActividades, setAvailableActividades] = useState<ActividadesPlanificadas[]>([]);
    const [servidorPlanificado, setServidorPlanificado] = useState<DetalleServidorPlanHEDTO>(defaultServidorPlanificado);
    const [modalConfirmacionActividad, setModalConfirmacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);

    const [grupoSeleccionado, setGrupoSeleccionado] = useState<number>(0);

    const [totalDevengado, setTotalDevengado] = useState(0);

    useEffect(() => {
        // Llamar a la función para obtener actividades disponibles
        ObtenerActividadesByRegimen(idRegimenLaboral).then(result => {
            if (result.status === 200 && result.dataResponse) {
                setAvailableActividades(result.dataResponse);
            }
        });
    }, [ObtenerActividadesByRegimen, idRegimenLaboral]);

    useEffect(() => {
        if (actividades.length > 0) {
            setinitialRows(actividades)
        }
    }, [actividades])


    // Inicializamos filas nuevas si hay menos de 5 actividades existentes
    while (rows.length < 5) {
        rows.push({
            idActividad: 0,
            idActividadPersona: 0,
            nombreActividad: '',
            horasSuplementarias: undefined,
            horasExtraordinarias: undefined,
            observacion: '',
            idEstructura: idUnidadAprueba ?? 0,
            nombreEstructura: nombreUnidadAprueba ?? ''
        });
    }


    const handleRowChange = (index: number, field: string, value: string | number) => {
        const updatedRows = [...rows];
        const regimenValidacion = regimenLaboralesPlan?.find(r => r.idRegimenLaboral === 999);

        if (regimenValidacion && regimenValidacion.presupuestoDevengar === 0) {
            Swal.fire({
                text: 'El presupuesto por devengar de su unidad está en cero. No puede ingresar actividades.',
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Warning",
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#243165',
            });
            return;
        }
        if (field === 'observacion') {
            value = (value as string).toUpperCase();
        } else if (field === 'idActividad' || field === 'horasSuplementarias' || field === 'horasExtraordinarias') {
            value = value !== '' ? Number(value) : 0;

            const paramHoras = paramsHorasMesPlanificacionHE.find(param => param.idregimenlaboral === idRegimenLaboral);

            if (paramHoras) {

                let currentHorasSuplementarias = field === 'horasSuplementarias' ? value : 0;
                let currentHorasExtraordinarias = field === 'horasExtraordinarias' ? value : 0;

                let totalHoras = currentHorasSuplementarias + currentHorasExtraordinarias;

                if (tipo === "MD" && factorMultiplicativo) {
                    const horasSuple = factorMultiplicativo * paramHoras.horasSuplementarias;
                    const horasExtraor = factorMultiplicativo * paramHoras.horasExtraordinarias;
                    const horasExtraorySuple = factorMultiplicativo * paramHoras.horasExtraySuple;

                    if (field === 'horasSuplementarias' && horasSuple > 0 && value > horasSuple) {
                        Swal.fire({
                            text: `Las horas suplementarias no pueden exceder ${horasSuple}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = horasSuple;
                    }
                    if (field === 'horasExtraordinarias' && horasExtraor > 0 && value > horasExtraor) {
                        Swal.fire({
                            text: `Las horas extraordinarias no pueden exceder ${horasExtraor}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = horasExtraor;
                    }
                    if (horasExtraorySuple > 0 && totalHoras > horasExtraorySuple) {
                        Swal.fire({
                            text: `La suma de horas suplementarias y extraordinarias no puede exceder ${horasExtraorySuple}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = field === 'horasSuplementarias' ? horasExtraorySuple - currentHorasExtraordinarias : horasExtraorySuple - currentHorasSuplementarias;
                    }

                }
                else {
                    if (field === 'horasSuplementarias' && paramHoras.horasSuplementarias > 0 && value > paramHoras.horasSuplementarias) {
                        Swal.fire({
                            text: `Las horas suplementarias no pueden exceder ${paramHoras.horasSuplementarias}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = paramHoras.horasSuplementarias;
                    }
                    if (field === 'horasExtraordinarias' && paramHoras.horasExtraordinarias > 0 && value > paramHoras.horasExtraordinarias) {
                        Swal.fire({
                            text: `Las horas extraordinarias no pueden exceder ${paramHoras.horasExtraordinarias}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = paramHoras.horasExtraordinarias;
                    }
                    if (paramHoras.horasExtraySuple > 0 && totalHoras > paramHoras.horasExtraySuple) {
                        Swal.fire({
                            text: `La suma de horas suplementarias y extraordinarias no puede exceder ${paramHoras.horasExtraySuple}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        value = field === 'horasSuplementarias' ? paramHoras.horasExtraySuple - currentHorasExtraordinarias : paramHoras.horasExtraySuple - currentHorasSuplementarias;
                    }
                }
            }

            if (field === 'idActividad') {
                // Encontrar el nombre de la actividad basado en idActividad
                const selectedActividad = availableActividades.find(act => act.idActividad === value);
                updatedRows[index].nombreActividad = selectedActividad ? selectedActividad.nombreActividad : '';
            }

        }


        updatedRows[index] = { ...updatedRows[index], [field]: value };
        setRows(updatedRows);
        updateServidorPlanificado(updatedRows);
    };

    const handleResetRow = (index: number) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            idActividad: 0,
            idActividadPersona: 0,
            nombreActividad: '',
            horasSuplementarias: 0,
            horasExtraordinarias: 0,
            observacion: '',
            idEstructura: idUnidadAprueba ?? 0,
            nombreEstructura: nombreUnidadAprueba ?? ''
        };
        setRows(updatedRows);
        updateServidorPlanificado(updatedRows);
    };

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>) => (value: string | number) => {
        setter(Number(value));
    };

    const updateServidorPlanificado = (updatedRows: ActividadesPlanificadas[]) => {

        setServidorPlanificado({
            ...servidorPlanificado,
            actividades: updatedRows
        });
    };

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    const validateTotalHours = () => {
        let totalHorasSuplementarias = 0;
        let totalHorasExtraordinarias = 0;
        rows.forEach(row => {
            if (row.horasSuplementarias) {
                totalHorasSuplementarias += row.horasSuplementarias;
            }
            if (row.horasExtraordinarias) {
                totalHorasExtraordinarias += row.horasExtraordinarias;
            }

        });

        const paramHoras = paramsHorasMesPlanificacionHE.find(param => param.idregimenlaboral === idRegimenLaboral);

        if (paramHoras) {

            if (tipo === "MD" && factorMultiplicativo) {
                const horasSuple = paramHoras.horasSuplementarias * factorMultiplicativo;
                const horasExtraor = paramHoras.horasExtraordinarias * factorMultiplicativo;
                const horasExtraorySuple = paramHoras.horasExtraySuple * factorMultiplicativo;

                if (horasSuple > 0 && totalHorasSuplementarias > horasSuple) {
                    Swal.fire({
                        text: `El total de horas suplementarias (${totalHorasSuplementarias}) excede el máximo permitido de ${horasSuple}.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }
                if (horasExtraor > 0 && totalHorasExtraordinarias > horasExtraor) {
                    Swal.fire({
                        text: `El total de horas extraordinarias (${totalHorasExtraordinarias}) excede el máximo permitido de ${horasExtraor}.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }
                if (paramHoras.horasSuplementarias === 0 && paramHoras.horasExtraordinarias === 0) {
                    const totalHoras = totalHorasSuplementarias + totalHorasExtraordinarias;
                    if (totalHoras > horasExtraorySuple) {
                        Swal.fire({
                            text: `La suma de horas suplementarias y extraordinarias (${totalHoras}) excede el máximo permitido de ${horasExtraorySuple}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        return false;
                    }
                }
            }
            else {

                if (paramHoras.horasSuplementarias > 0 && totalHorasSuplementarias > paramHoras.horasSuplementarias) {
                    Swal.fire({
                        text: `El total de horas suplementarias (${totalHorasSuplementarias}) excede el máximo permitido de ${paramHoras.horasSuplementarias}.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }
                if (paramHoras.horasExtraordinarias > 0 && totalHorasExtraordinarias > paramHoras.horasExtraordinarias) {
                    Swal.fire({
                        text: `El total de horas extraordinarias (${totalHorasExtraordinarias}) excede el máximo permitido de ${paramHoras.horasExtraordinarias}.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }
                if (paramHoras.horasSuplementarias === 0 && paramHoras.horasExtraordinarias === 0) {
                    const totalHoras = totalHorasSuplementarias + totalHorasExtraordinarias;
                    if (totalHoras > paramHoras.horasExtraySuple) {
                        Swal.fire({
                            text: `La suma de horas suplementarias y extraordinarias (${totalHoras}) excede el máximo permitido de ${paramHoras.horasExtraySuple}.`,
                            imageUrl: `${WarningSVG}`,
                            imageHeight: 100,
                            imageAlt: "Warning",
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#243165',
                        });
                        return false;
                    }
                }
            }
        }
        return true;
    };


    const validateTotalCosts = () => {
        let totalHorasSuplementarias = 0;
        let totalHorasExtraordinarias = 0;
        let totalCostSuplementarias = 0;
        let totalCostExtraordinarias = 0;

        const valorHora = calcularValorHorabyRMU(parseInt(rmu)); // Calcular el valor de la hora según RMU
        const valorHoraSuplementaria = calcularValorHoraSuplementariasbyRMU(idRegimenLaboral, valorHora);
        const valorHoraExtraordinaria = calcularValorHoraExtraordinariabyRMU(idRegimenLaboral, valorHora);

        // Filtrar solo las filas relevantes
        const rowsFiltrados = rows.filter(r => r.idEstructura === idUnidadAprueba);
        
        const regimenLaboral = regimenLaboralesPlan?.find(r => r.idRegimenLaboral === 999);
        //let presupuestoDisponible = regimenLaboral ? regimenLaboral.presupuestoDevengar : 0;
        let presupuestoDisponible = regimenLaboral ? regimenLaboral.presupuestoCodificado - regimenLaboral.devengadoPagado : 0;
        //console.log(presupuestoDisponible)

        //Considerar el valor de la planificacion del mes anterior 
        if (regimenLaboral && regimenLaboral.planificacionMesAnterior && regimenLaboral.devengadoNoPagado < regimenLaboral.planificacionMesAnterior) {
            presupuestoDisponible -= regimenLaboral ? regimenLaboral.planificacionMesAnterior : 0;
        }
        else if(regimenLaboral) {
            presupuestoDisponible -= regimenLaboral ? regimenLaboral.devengadoNoPagado : 0;
        }

        presupuestoDisponible = presupuestoDisponible - (regimenLaboral ? regimenLaboral.planificadoActual : 0);

        if (idUnidadAprueba && unidadesEspeciales.includes(idUnidadAprueba) && regimenLaboral) {
            presupuestoDisponible = regimenLaboral.presupuestoCodificado - regimenLaboral.devengadoPagado - regimenLaboral.devengadoNoPagado - (regimenLaboral ? regimenLaboral.planificadoActual : 0);
        }
        //console.log(presupuestoDisponible)

        


        rowsFiltrados.forEach((row, index) => {
            const previousRow = initialRows[index];
            // Asegurarse de que si no hay horas, se considere como 0
            const horasSuplementarias = row.horasSuplementarias || 0;
            const horasExtraordinarias = row.horasExtraordinarias || 0;

            // Si las horas suplementarias han cambiado, restar el valor anterior antes de sumar el nuevo
            if (previousRow) {//&& previousRow.horasSuplementarias !== horasSuplementarias) {
                const previousCostSuplementarias = calcularValorTotalSuplementarias(valorHoraSuplementaria, previousRow.horasSuplementarias || 0);
                presupuestoDisponible += previousCostSuplementarias; // Devolver al presupuesto el valor anterior
            }
            // Si las horas extraordinarias han cambiado, restar el valor anterior antes de sumar el nuevo
            if (previousRow) { //&& previousRow.horasExtraordinarias !== horasExtraordinarias) {
                const previousCostExtraordinarias = calcularValorTotalExtraordinarias(valorHoraExtraordinaria, previousRow.horasExtraordinarias || 0);
                presupuestoDisponible += previousCostExtraordinarias; // Devolver al presupuesto el valor anterior
            }

            // Ahora sumar las horas actuales
            totalHorasSuplementarias += horasSuplementarias;
            totalHorasExtraordinarias += horasExtraordinarias;

            totalCostSuplementarias += calcularValorTotalSuplementarias(valorHoraSuplementaria, horasSuplementarias);
            totalCostExtraordinarias += calcularValorTotalExtraordinarias(valorHoraExtraordinaria, horasExtraordinarias);

        });

        const totalCost = totalCostSuplementarias + totalCostExtraordinarias;
        
        // Verificar si el nuevo costo total supera el presupuesto disponible
        if (totalCost > presupuestoDisponible) {
            Swal.fire({
                text: `No existe suficiente presupuesto para continuar con la planificación.`,
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Warning",
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#243165',
            });
            return false;
        }

        return true;
    };



    const validateActividades = (servidorPlanificado: DetalleServidorPlanHEDTO, initialRows: ActividadesPlanificadas[]) => {
        if (servidorPlanificado.actividades.length > 0) {

            const actividadesValidas = servidorPlanificado.actividades.filter(act => act.idActividad !== 0);

            //Esto significa que el servidor tenia actividades asignadas pero el directivo le ha quitado todas,
            //por lo que se deja continuar la acción para que se eliminen.
            if (initialRows.length > 0 && actividadesValidas.length === 0) {
                return true;
            }

            if (actividadesValidas.length === 0) {
                Swal.fire({
                    text: `No se han planificado actividades al servidor.`,
                    imageUrl: `${WarningSVG}`,
                    imageHeight: 100,
                    imageAlt: "Warning",
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#243165',
                });
                return false;
            }

            for (let act of actividadesValidas) {
                if ((act.horasSuplementarias === 0 || act.horasSuplementarias === undefined) && (act.horasExtraordinarias === 0 || act.horasExtraordinarias === undefined)) {
                    Swal.fire({
                        text: `La actividad "${act.nombreActividad}" tiene tanto horas suplementarias como extraordinarias en 0.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }

                if (act.observacion === "" && tipo === "PL") {
                    Swal.fire({
                        text: `Debe de ingresar la observación de la actividad.`,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100,
                        imageAlt: "Warning",
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#243165',
                    });
                    return false;
                }
            }

            return true;
        } else {
            Swal.fire({
                text: `No se han realizado ediciones en las actividades del servidor.`,
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Warning",
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#243165',
            });
            return false;
        }
    };



    const handleSave = async () => {
        if (!validateTotalHours()) {
            return;
        } else if (!validateActividades(servidorPlanificado, initialRows)) {
            return;
        } else if (tipo === "PL" && !validateTotalCosts()) {
            return;
        }

        onPlanificacionSave(servidorPlanificado);
    };

    const handleCancelar = async () => {
        onCancel();
    };

    const mostrarBotones = useMemo(() => {
        var estadosPuedeGuardar = ['', 'RT', 'RE', 'MO']
        if(tipo === "MD"){
            estadosPuedeGuardar = ['', 'AP', 'NE']
        }   
        const estadoPlanif = (estadosPuedeGuardar.includes(estadoPlanificacion.trim()))
        return estadoPlanif;
    }, [estadoPlanificacion]);

    const { totalSuplementarias, totalExtraordinarias } = useMemo(() => {
        let totalSuplementarias = 0;
        let totalExtraordinarias = 0;

        rows.forEach(row => {
            if (row.horasSuplementarias) {
                totalSuplementarias += row.horasSuplementarias;
            }
            if (row.horasExtraordinarias) {
                totalExtraordinarias += row.horasExtraordinarias;
            }
        });

        return { totalSuplementarias, totalExtraordinarias };
    }, [rows]);

    return (
        <div>
            <div className="d-flex align-items-center justify-content-start mb-3" style={{ width: '100%' }}>
                <Label for="grupoActividad" className="mr-2" style={{ whiteSpace: 'nowrap' }}>Grupo de actividades: </Label>
                <SelectItem2
                    options={[
                        { value: "0", label: "SIN GRUPO" }, // Opción para seleccionar "Sin grupo"
                        ...gruposActividad.map(reg => ({
                            value: reg.idHeGrupoActividad.toString(),
                            label: reg.nombreGrupo.toString()
                        }))
                    ]}
                    placeholder=""
                    name="grupoActividad"
                    id="grupoActividad"
                    icon="fa-caret-down"
                    value={grupoSeleccionado}
                    onChange={handleChangeSelect(setGrupoSeleccionado)}// Ajusta el ancho del select según tus necesidades
                />
            </div>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th>#</th>
                        <th>Unidad</th>
                        <th>Actividad</th>
                        {tipo === "PL" && <th>Descripción específica de la actividad</th>}
                        <th>Horas <br />Suplem.</th>
                        <th>Horas<br />Extraord.</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((actividad, index) => {
                        const preselectedActivities = rows.filter((v) => v.idActividad !== 0 && v.idEstructura === idUnidadAprueba)//rows.map(row => row.idActividad).filter(id => id !== 0);
                        const selectedActivities = preselectedActivities.map((v) => v.idActividad);
                        const filteredActivities = availableActividades.filter(act => !selectedActivities.includes(act.idActividad) || act.idActividad == actividad.idActividad);
                        const disabledPorSerDeOtraUnidad = idUnidadAprueba && actividad.idEstructura && actividad.idEstructura > 0 && actividad.idEstructura !== idUnidadAprueba; //Si es una actividad de otra unidad, no puedo modificarla

                        const widthColumnaActividad = tipo === "PL" ? "25%" : "55%"
                        //const widthColumnaHoras = tipo === "PL" ? "10%" : "15%"

                        const isDisabled = actividad.idActividad === 0 || disabledPorSerDeOtraUnidad;

                        let filteredActividadesbyGrupo = filteredActivities

                        if (grupoSeleccionado !== 0) {
                            filteredActividadesbyGrupo = filteredActivities.filter(act => act.idGrupo === grupoSeleccionado || act.idActividad == actividad.idActividad);
                        }


                        return (
                            <tr key={index} className='rows_tabla_planificacion_he'>
                                <td className="centrado">{index + 1}</td>
                                <td style={{ width: '20%' }} title={actividad.nombreEstructura}>
                                    {actividad.nombreEstructura}
                                </td>
                                <td style={{ width: widthColumnaActividad }} title={actividad.nombreActividad}>
                                    <>

                                        {
                                            !!actividad.idActividadPersona ? (
                                                <Input
                                                    className="input-border-bottom"
                                                    type="text"
                                                    value={actividad.nombreActividad}
                                                    disabled={!!actividad.idActividadPersona}
                                                />


                                            ) : (
                                                <Input
                                                    className="input-border-bottom"
                                                    type="select"
                                                    value={actividad.idActividad}
                                                    onChange={(e) => handleRowChange(index, 'idActividad', e.target.value)}
                                                >
                                                    <option value={0}>Seleccione una actividad</option>
                                                    {filteredActividadesbyGrupo.map((act) => (
                                                        <option key={act.idActividad} value={act.idActividad}>
                                                            {act.nombreActividad}
                                                        </option>
                                                    ))}
                                                </Input>
                                            )
                                        }

                                    </>
                                    {/* <Input
                                        className="input-border-bottom"
                                        type="select"
                                        value={actividad.idActividad}  // Preselecciona la actividad guardada
                                        onChange={(e) => handleRowChange(index, 'idActividad', e.target.value)}
                                        disabled={!!actividad.idActividadPersona} // Deshabilitar si ya tiene una actividad guardada
                                    >
                                        <option value={0}>Seleccione una actividad</option>
                                        {filteredActivities.map((act) => (
                                            <option key={act.idActividad} value={act.idActividad}>
                                                {act.nombreActividad}
                                            </option>
                                        ))}
                                    </Input> */}
                                </td>
                                {tipo === "PL" &&
                                    <td style={{ width: '40%' }} title={actividad.observacion}>
                                        <Input
                                            className="input-border-bottom"
                                            type="text"
                                            value={actividad.observacion}
                                            onChange={(e) => handleRowChange(index, 'observacion', e.target.value)}
                                            placeholder="Describir la acción relacionada a la actividad seleccionada y el lugar en caso que aplique"
                                            disabled={!!actividad.idActividadPersona || isDisabled} // Deshabilitar si es una actividad existente y tiene valor
                                            maxLength={400}
                                        />
                                    </td>
                                }
                                <td style={{ width: '5%' }} className="centrado">
                                    <Input
                                        className="center-input-text input-border-bottom"
                                        type="number"
                                        value={(!actividad.horasSuplementarias || actividad.horasSuplementarias === 0) ? "" : actividad.horasSuplementarias}
                                        min={1}
                                        onChange={(e) => handleRowChange(index, 'horasSuplementarias', e.target.value)}
                                        placeholder="Horas Suplem."
                                        disabled={isDisabled} //Si es una actividad de otra unidad, no puedo modificarla
                                    />
                                </td>
                                <td style={{ width: '5%' }} className="centrado">
                                    <Input
                                        className="center-input-text input-border-bottom"
                                        type="number"
                                        value={(!actividad.horasExtraordinarias || actividad.horasExtraordinarias === 0) ? "" : actividad.horasExtraordinarias}
                                        min={1}
                                        onChange={(e) => handleRowChange(index, 'horasExtraordinarias', e.target.value)}
                                        placeholder="Horas Extraord."
                                        disabled={isDisabled} //Si es una actividad de otra unidad, no puedo modificarla
                                    />
                                </td>



                                <td style={{ width: '5%' }} className="centrado">
                                    {((puedeRealizarAccion !== undefined && puedeRealizarAccion === true) || puedeRealizarAccion === undefined) && (
                                        <>
                                            {mostrarBotones && !disabledPorSerDeOtraUnidad && (
                                                <a className="btn-detalles" title="Eliminar Actividad" onClick={() => handleResetRow(index)}><EliminarSVG style={{ width: '24px', height: '24px' }} /></a>
                                            )}
                                        </>
                                    )}


                                </td>
                            </tr>
                        );
                    })}

                </tbody>
                <tfoot>
                    <tr className='fila-totales'>
                        <td className="centrado" colSpan={tipo === "PL" ? 4 : 3}><strong>TOTAL DE HORAS:</strong></td>
                        <td className="centrado"><strong>{totalSuplementarias}</strong></td>
                        <td className="centrado"><strong>{totalExtraordinarias}</strong></td>
                        <td></td>
                    </tr>
                </tfoot>
            </Table>
            {((puedeRealizarAccion !== undefined && puedeRealizarAccion === true) || puedeRealizarAccion === undefined) && (
                <>
                    {mostrarBotones && (
                        <Row className=" d-flex justify-content-center">
                            <Col className="d-flex" md="2">
                                <Button className='btn-cancelar' onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                            </Col>
                            <Col className="d-flex" md="2">
                                <Button color="secondary" onClick={handleSave}>
                                    Guardar Actividades
                                </Button>
                            </Col>


                        </Row>
                    )}
                </>
            )}


        </div>
    );
};


export default TableActividadServidorHE;